export default __webpack_public_path__ + "69cd69535c77cb53359c72805dda8df3.svg";